import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { actions as workTicketActions, fetchWorkTicketWithFilters } from './store/slice';
import { Link } from 'react-router-dom';
import { selectWorkTicketFilters } from './store/selectors';

const { setFromDate, setToDate } = workTicketActions;

const WorkTicketFilter = () => {
  const dispatch = useDispatch();

    const { fromDate, toDate } = useSelector(selectWorkTicketFilters);

  const onSearch = () => {
    dispatch(fetchWorkTicketWithFilters());
  };
  return (
    <div className="card visible" id="filter_inputs" style={{ display: 'block' }}>
      <div className="card-body pb-0">
        <div className="row">
        <div className="col-lg-2 col-md-3 col-sm-6 col-12">
            <div className="input-blocks">
              <label>
                From<span className="text-danger">*</span>
              </label>
              <input
                type="date"
                value={fromDate || ''}
                onChange={e => dispatch(setFromDate(e.target.value))}
                className="form-control"
                placeholder=""
              />
            </div>
          </div>
          <div className="col-lg-2 col-md-3 col-sm-6 col-12">
            <div className="input-blocks">
              <label>
                To <span className="text-danger">*</span>
              </label>
              <input
                type="date"
                value={toDate || ''}
                onChange={e => dispatch(setToDate(e.target.value))}
                className="form-control"
                placeholder=""
              />
            </div>
          </div>

     
     <div className="col-lg-3 col-sm-6 col-12 ms-auto">
            <div className="input-blocks">
              <Link className="btn btn-filters ms-auto" onClick={onSearch}>
                {' '}
                <i data-feather="search" className="feather-search" /> Search{' '}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default WorkTicketFilter;
